var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"audit-page"},[_c('audit-info',{attrs:{"status":_vm.status}}),(_vm.status === 2)?_c('audit-table',{attrs:{"status":_vm.status}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }